import { CardCorners, ContinueWatchCard } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { useCallback, type MouseEvent } from 'react'
import type { IContinueWatchingCardFormat } from '~/entities/continue-watching'
import {
  isContinueWatchingVodAndLocked,
  pinLockFeatureContinueWatchingModel,
} from '~/features/pin-lock/continue-watching'
import {
  VodCardHorizontalCoversMap,
  VodCardVerticalCoversMap,
} from '~/shared/ui/components/cardCovers'
import type { ViewRow } from '../../model'
import { getCWCardPadding, getCardFonts } from '../lib'

export const CWCard = ({
  row,
  item,
}: {
  row: ViewRow
  item: IContinueWatchingCardFormat
}) => {
  const {
    progress,
    contentName,
    landscapeImageUrl,
    portraitImageUrl,
    description,
    viewedTime,
    contentId,
    contentType,
    locked,
  } = item

  const {
    appearance: {
      style: { posterSize, posterOrientation },
    },
  } = row

  const selectContinueWatchingEvent = useUnit(
    pinLockFeatureContinueWatchingModel.selectContinueWatching
  )

  const handleSelectContinueWatching = useCallback(
    (e: MouseEvent<Element>) => {
      const tvShowConfig =
        item.contentType === 'EPISODE'
          ? {
              tvShowId: item.tvShowId,
              seasonId: item.seasonId,
              withSeason: item.withSeason,
            }
          : null
      e.stopPropagation()
      e.preventDefault()
      selectContinueWatchingEvent({
        contentId: contentId,
        contentName: contentName,
        contentType: contentType,
        locked: locked,
        ...tvShowConfig,
      })
    },
    [
      item,
      contentId,
      contentName,
      contentType,
      locked,
      selectContinueWatchingEvent,
    ]
  )

  const isLocked = isContinueWatchingVodAndLocked(item)
  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? landscapeImageUrl : portraitImageUrl

  const { titleFont, labelFont } = getCardFonts(posterSize)
  const padding = getCWCardPadding(posterSize)
  const covers =
    posterOrientation === 'HORIZONTAL'
      ? VodCardHorizontalCoversMap
      : VodCardVerticalCoversMap

  return (
    <ContinueWatchCard
      onClick={handleSelectContinueWatching}
      corners={CardCorners.CORNERS_25}
      titleFont={titleFont}
      progress={progress}
      posterUrl={posterUrl}
      title={contentName ?? ''}
      description={description}
      durationTitle={viewedTime}
      locked={isLocked}
      lockedTitle={contentName}
      padding={padding}
      labelFont={labelFont}
      covers={covers}
      ageRatingLabel=''
    />
  )
}
